import React from 'react';
import styled from 'styled-components';
import vars from '../lib/styled';
import SearchInput from './SearchInput';
import Grid from './Grid';

import FollowSocial from './FollowSocial';

const Wrapper = styled.section`
    background: #272727;
    border-bottom: 2px solid ${vars.accent};

    label {
        border-color: #fff;
    }

    input {
        color: #fff !important;
    }
`;

const Container = styled.div`
    margin: 0 auto;
    padding: 3vh 0;
    width: ${vars.container};
`;

export default (props) => (
    <Wrapper>
        <Container>
            <Grid
                style={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <div style={{ flex: 1 }}>
                    <SearchInput {...props} />
                </div>
                <FollowSocial />
            </Grid>
        </Container>
    </Wrapper>
);
